<div class="card" [class.lighter-shade]="noOfVehicles">
  @if (!noOfVehicles) {
    <p class="text-center heading pad-20" data-cy="quoteSidebarVehicleQuote">Your Vehicle Quote</p>
  }
  <div class="row gray pad-10 flex-center" [class.gray]="!noOfVehicles">
    <div class="column six pad-right-10">
      <div class="semi-bold">
        @if (noOfVehicles) {
          <div>New Premium</div>
        }
        @if (noOfVehicles) {
          <div class="flex-center pad-vertical-5">
            @for (icon of icons; track icon) {
              <div class="icon-auto margin-horizontal-2"></div>
            }
            <div class="pad-left-5">{{ noOfVehicles }} vehicles</div>
          </div>
        }
        @if (vehicleName && !needRecalculation && !noOfVehicles) {
          <span data-cy="quoteSidebarSameCoverage"> Same Coverage As Your {{ vehicleName }}</span>
        }
        @if (needRecalculation && !noOfVehicles) {
          <span>Custom Coverage</span>
        }
      </div>
    </div>
    @if (!needRecalculation) {
      <div class="column six" data-cy="quoteSidebarQuoteBlock">
        <div class="row">
          <div class="column ten" data-cy="quoteSidebarQuoteBlockAmount">
            <p class="quote-amount-big float-right">${{ quoteData?.quoteMonthlyDollars }}</p>
          </div>
          <div class="column two pad-right-20 pad-top-10">
            <p class="quote-amount-small">.{{ quoteData?.quoteMonthlyCents }}</p>
            <p class="quote-amount-small">/MO</p>
          </div>
        </div>
        <div class="row">
          <div class="column twelve">
            <strong class="float-right" data-cy="quoteSidebarQuoteBlockAmountTerm"
              >${{ quoteData?.quoteTotalAmount }} / {{ quoteData?.quoteTerm }} mos</strong
            >
          </div>
        </div>
      </div>
    }
    @if (needRecalculation) {
      <div class="column six" data-cy="quoteSidebarQuoteRecalc">
        <p class="pad-left-30 text-right">Recalculate for Estimate</p>
      </div>
    }
  </div>

  <div class="text-center action">
    @if (needRecalculation) {
      <div class="row pad-top-10">
        <button
          ds-button
          class="-outline-white"
          (click)="recalculateQuote.emit()"
          data-cy="quoteSidebarQuoteRecalcButton"
        >
          Recalculate
        </button>
      </div>
    }
    @if (showResetCoverageButton) {
      <div class="row pad-vertical-20">
        <a (click)="resetQuote.emit()" data-cy="quoteSidebarQuoteResetLink">Reset Coverage</a>
      </div>
    }
  </div>
</div>
